<template>
  <div class="contain">
    <div class="total-title">
      <img src="../../../../../../static/img/28.png" alt="" />
      <span> 专利海外布局 </span>
      <img src="../../../../../../static/img/21.png" alt="" />
    </div>
    <div class="echart-bg">
      <!-- <div class="num-text">PCT专利总数:{{total}}</div> -->
      <div class="num-text">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiperSlide :key="index" v-for="(item, index) in pctArr">
              <span :title="item.name">{{item.name}}: {{item.value}}</span>
            </swiperSlide>
          </swiper>
      </div>
      <div ref="echart" class="echart"></div>
    </div>
  </div>
</template>

<script>
import { getValuePCT } from '@/api/databaseBin'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BaseMixin from '@/views/_mixin'

export default {
  mixins: [BaseMixin],
  name: 'PCT',
  data: () => ({
    option: {},
    pctEchart: null,
    total: null,
    pctArr: [],
    swiperOption: {
      init: false,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      direction: 'vertical',
      autoHeight: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1, // 页面中的板块数量
      loop: true,
      autoplay: {
        delay: 2000
        // disableOnInteraction: false
      }
    }
  }),
  components: {swiper, swiperSlide},
  computed: {
    PCTSwiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', () => { this.resize() })
  },
  methods: {
    echartClick(params) {
      let exp = '数据源=' + params.data.enName
      if (params.data.name === '其他') {
        exp = `数据源=(US or EP or JP or KR or GB or FR or DE or RU or CH or WO or OTHER) ${params.data.exp}`
      }
      this.jumpIpi(exp, 'isMerge', 'publicOrder')
    },
    async initChart() {
      this.pctEchart = this.$echarts.init(this.$refs.echart, null, {renderer: 'svg'})
      this.pctEchart.on('click', params => {
        this.echartClick(params)
      })
      const result = await getValuePCT()
      const { datas, total } = result[this.dataMapping]
      const obj = {
        '世界知识产权组织国际局(WIPO)': 'WIPO',
        美国: 'US',
        '欧洲专利局(EPO)': 'EPO',
        日本: 'JP',
        其他: 'OTHER'
      }
      datas.forEach(item => {
        item.value = item.count
        if (item.name.indexOf('WO') !== -1) {
          item.name = 'WIPO'
        }
        if (item.name.indexOf('EP') !== -1) {
          item.name = 'EPO'
        }
        item.type = obj[item.name]
        const temp = item.name
        item.name = item.cnName
        item.enName = temp
        // item.name = item.name + item.per
      })
      this.pctArr = datas
      this.total = total
      console.log(datas, 'datas')
      const option = {
        color: [
          '#0044E8',
          '#1E6DF7',
          '#529DFD',
          '#68CAFE',
          '#90FAFF'
        ],
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            center: ['50%', '50%'],
            label: {
              show: true,
              fontSize: '14',
              distance: 0,
              color: '#fff',
              formatter: (v) => {
                return v.name + ': ' + v.value
              }
            },
            data: datas
          }
        ]
      }
      this.pctEchart.setOption(option)
      this.$nextTick(() => {
        this.PCTSwiper.init()
      })
    },
    resize() {
      this.pctEchart.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-wrapper {
  height: 20px !important;
  text-align: center !important;
  .swiper-slide {
    height: 20px !important;
  }
}
.echart {
  margin-top: 44px !important;
}
</style>
